import { fetchOperation, getMaster } from "utils/api";

export const createAgent = async (params) => {
  console.log("createAgent() => ", params);
  const isoAgentCreateRequest = {
    ...params,
    componentAllowed: [...JSON.parse(params.permission)],
  };
  delete isoAgentCreateRequest.permission;
  return await fetchOperation("/agent", {
    ...isoAgentCreateRequest,
  });
};

export const getRoleList = async (params) => {
  return await getMaster("/roles", {
    sort: "created_date,desc",
    ...params,
  });
};
